import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 1,
      padding: 1,
      margin: theme.spacing(2, 0),
      borderBottom: `solid ${theme.spacing(0.5)} ${theme.palette.info.main}`,
    },
    status: {
      display: 'flex',
      gap: 0.5,
      alignItems: 'center',
      fontWeight: 'bold',
    },
    children: { display: 'flex', gap: 1 },
  };
};
